export default "__VITE_ASSET__CymvAVCr__"